interface LoadingStateProps {
  /** Visible loading message; also announced to screen readers via role="status". */
  readonly label?: string;
}

/**
 * Three-dot bounce loader matching the static prototype's loading state.
 * Use whenever a page or section is fetching from the API.
 *
 * @example
 *   if (isLoading) return <LoadingState label="Loading metros…" />;
 */
export function LoadingState({ label = 'Loading…' }: LoadingStateProps) {
  return (
    <div role="status" aria-live="polite" className="flex flex-col items-center gap-3 py-12 text-text-3">
      <div className="flex gap-1.5" aria-hidden="true">
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className="h-2 w-2 animate-[bounce_1.4s_ease-in-out_infinite] rounded-full bg-blue"
            style={{ animationDelay: `${i * 160}ms` }}
          />
        ))}
      </div>
      <span className="text-sm">{label}</span>
    </div>
  );
}
